module.exports = __webpack_public_path__ + "img/1699439223654-IMG_7889.jpeg.6ca11079.webp";